module.exports = __webpack_public_path__ + "img/logo1.b08afea4.png";